{
  "auth.login.otp.phone.back.button_label": "Atrás",
  "auth.login.otp.phone.form.continue.button_label": "Continuar",
  "auth.login.otp.phone.form.country_code.label": "Código de país",
  "auth.login.otp.phone.form.country_code.invalid_error": "Selecciona un código de país.",
  "auth.login.otp.phone.form.phone_number.helper_text": "Te enviaremos un código por mensaje de texto para confirmar tu número.",
  "auth.login.otp.phone.form.phone_number.label": "Número de teléfono",
  "auth.login.otp.phone.form.phone_number.placeholder": "Número de teléfono",
  "auth.login.otp.phone.form.phone_number.invalid_error": "No se puede enviar el código a este número de teléfono. Intenta usar uno diferente o inicia sesión con correo electrónico.",
  "auth.login.otp.phone.passcode.form.label": "Código",
  "auth.login.otp.phone.passcode.form.placeholder": "Código",
  "auth.login.otp.phone.passcode.form.resend.link_text": "¿No recibiste el mensaje? Reenviar código",
  "auth.login.otp.phone.passcode.form.resend.link_text.resending": "Reenviando...",
  "auth.login.otp.phone.passcode.form.switch_method.link_text": "Enviar código al correo electrónico mejor",
  "auth.login.otp.phone.passcode.helper_text": "Ingresa el código enviado a"
}
